import { useMemo } from 'react'

import { usePfCatalogue } from 'dataQueries/purchaseFlowRevamp.query'
import type { CartItemId, ResolvedShellProduct, ResolvedVariant } from 'models/purchaseFlowRevamp'

import { usePfStore } from '../store'

export interface CartLineCatalogueEntry {
  shell: ResolvedShellProduct | null
  variant: ResolvedVariant | null
}

/**
 * The catalogue product and variant a cart line was added as, or nulls while the catalogue loads or the
 * line is gone. Stable while neither changes.
 *
 * @example
 * const { variant } = useCartLineCatalogueEntry(cartItemId)
 * const policy = variant?.inputImagePolicy
 */
export function useCartLineCatalogueEntry(cartItemId: CartItemId): CartLineCatalogueEntry {
  const shellProductId = usePfStore((s) => s.items.find((i) => i.id === cartItemId)?.shellProductId ?? null)
  const variantId = usePfStore((s) => s.items.find((i) => i.id === cartItemId)?.variantId ?? null)
  const catalogue = usePfCatalogue().data

  return useMemo(() => {
    const shell = catalogue?.shellProducts.find((item) => item.id === shellProductId) ?? null
    return { shell, variant: shell?.variants?.find((item) => item.id === variantId) ?? null }
  }, [catalogue, shellProductId, variantId])
}
